"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "aiello-del-sabato": {
    "0a8526bd": [{
      "hkey": "d0b26c51",
      "slug": "aiello-del-sabato",
      "name": "Aiello del Sabato",
      "primary": true,
      "skipSearch": false
    }],
    "sabina": [{
      "hkey": "d0b26c51",
      "slug": "aiello-del-sabato",
      "name": "Aiello del Sabato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e122573": [{
      "hkey": "d0b26c51",
      "slug": "aiello-del-sabato",
      "name": "Aiello del Sabato",
      "primary": true,
      "skipSearch": false
    }],
    "tavernola-san-felice": [{
      "hkey": "d0b26c51",
      "slug": "aiello-del-sabato",
      "name": "Aiello del Sabato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;